// extracted by mini-css-extract-plugin
module.exports = {"descriptionHeader":"PCSRoI","descriptionText":"iJ1vW3","marketcapRank":"ISITbO","lastParagrath":"HTqNuo","formatedBackColor":"lzXGqJ","extraDescriptionWrapper":"QJcEBK"};